__turbopack_context__.v({
  "accordion": "index-module-scss-module__9vBK3a__accordion",
  "applied": "index-module-scss-module__9vBK3a__applied",
  "appliedSection": "index-module-scss-module__9vBK3a__appliedSection",
  "applyBtn": "index-module-scss-module__9vBK3a__applyBtn",
  "blinker": "index-module-scss-module__9vBK3a__blinker",
  "body": "index-module-scss-module__9vBK3a__body",
  "chevron": "index-module-scss-module__9vBK3a__chevron",
  "discountError": "index-module-scss-module__9vBK3a__discountError",
  "divider": "index-module-scss-module__9vBK3a__divider",
  "form": "index-module-scss-module__9vBK3a__form",
  "header": "index-module-scss-module__9vBK3a__header",
  "input": "index-module-scss-module__9vBK3a__input",
  "note": "index-module-scss-module__9vBK3a__note",
  "remove": "index-module-scss-module__9vBK3a__remove",
  "saveMoney": "index-module-scss-module__9vBK3a__saveMoney",
  "tagIcon": "index-module-scss-module__9vBK3a__tagIcon",
  "title": "index-module-scss-module__9vBK3a__title",
  "wrapper": "index-module-scss-module__9vBK3a__wrapper",
});
